<template>
<div>
  <v-layout row wrap>
    <v-flex 
      xs6 md6 
      v-for="(item, $index) in list" :key="$index" 
      @click="goToShowPost(item)" 
      class="pointer" 
      :class="{'pa-1': $vuetify.breakpoint.smAndDown, 'pt-4 pr-4': $vuetify.breakpoint.mdAndUp }"
    >
      <PostCardMobile 
        v-if="$vuetify.breakpoint.smAndDown"
        :post="item"
        marginX="mx-0"
      />
      <PostCard :post="item" v-else />
    </v-flex>
  </v-layout>
  <v-flex sm12 pt-4>
    <infinite-loading @infinite="infiniteHandler">
      <div slot="spinner" class="subheading">Cargando...</div>
      <div slot="no-more" class="subheading">No hay más noticias...</div>
      <div slot="no-results" class="subheading">No hay resultados</div>
    </infinite-loading>
  </v-flex>
</div>
</template>

<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import PostCard from "@/components/Posts/PostCard"
import PostCardMobile from "@/components/Posts/PostCardMobile"

export default {
  components: {
    PostCard,
    PostCardMobile
  },
  data() {
    return {
      page: 1,
      list: []
    };
  },
  props: {
    category: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapState("user", ["current_user"])
  },
  methods: {
    ...mapMutations("posts", ["setPost", "setPosts"]),
    infiniteHandler($state) {
      let api = `${process.env.VUE_APP_API_URL}/posts`;
      axios.get(api, { params: { page: this.page, view_as: localStorage.getItem("view_as"), category: this.category }}).then(({ data }) => {
        if (data.hits.length) {
          this.page += 1;
          this.list.push(...data.hits);
          this.setPosts(this.list);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    goToShowPost(item) {
      this.setPost(item);
      this.$router.push({
        name: "post-show",
        params: { id: item.id, slug: item.slug }
      });
    }
  }
};
</script>
